import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { ApplicationUser } from './ApplicationUser';

export class UserAcount extends ApplicationUser {
    _originalTypeClassName = "ekylikeio.BO.UserAcount";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
UserAcount.translate = translateService;
}
super();
this._key = this.UserName = ""; 
}

static translate: TranslateService;
_key: any;
Parent:any;
ActiveOrder:any;
static setParent = ($this, value) => {
var oldValue = $this.Parent;
$this.Parent = value;
if (value != null) {
if (oldValue != null && oldValue.UserAcount != null) { oldValue.UserAcount = null; }
if ($this.Parent.UserAcount !== $this) {
Domain.Parent.setUserAcount(value, $this);
}
}
}
static setActiveOrder = ($this, value) => {
var oldValue = $this.ActiveOrder;
$this.ActiveOrder = value;
if (value != null) {
}
}

static GetActive(): any{return Joove.Common.cast(window._context.currentUser, "Domain.UserAcount");
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.UserName == null || $this.UserName == "";
            }


}